const { h, render, Component } = require('preact');
const { Portal } = require('preact-portal');
const PreChatPopUpView = require('./boldchat/prechat');
const { route } = require('preact-router')
const ConfirmationPopup = require('../confirmation_popup/confirmation_popup')

class ChatView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      thankyou: false,
      confirmationPopup: false
    }
    this.liveChatContainer = null;
    this.setLiveChatContRef = this.setLiveChatContRef.bind(this);
    this.open = this.open.bind(this);
    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.routeToThankYouPage = this.routeToThankYouPage.bind(this)
    this.handleCloseConfirmationPopup = this.handleCloseConfirmationPopup.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    this.updateChannelSwitchState = this.updateChannelSwitchState.bind(this);
    this.resetChat = this.resetChat.bind(this);
  }

  setLiveChatContRef(element) { 
    this.liveChatContainer = element 
  };

  routeToThankYouPage() {
    route(`/customer_support/web/thank_you?channel=chat`)
  }

  handleCloseConfirmationPopup() {
    this.setState({
      confirmationPopup: false,
      open: false
    })
  }

  handleBackButtonClick() {
    this.setState({
      open: false, confirmationPopup: false
    });
  }

  handleCloseButtonClick() {
    this.setState({
      open: false, confirmationPopup: false
    });
    window.pdtBCAPIs.closeChat();
    var channelsContainer = document.getElementsByClassName('all-channels')[0]
    channelsContainer.dispatchEvent(new CustomEvent('show-popup',{detail : {type: this.state.type}}));
  }

  getTranslationObject(){
    var translationObject = {}
    translationObject.closeText = I18n.translate('js.modules.web_2018.close_text_form')
    translationObject.selectingText = I18n.translate('js.modules.web_2018.selecting_text_chat')
    translationObject.sureText = I18n.translate('js.modules.web_2018.sure_text_chat')
    translationObject.backButtonText = I18n.translate('js.modules.web_2018.back_button_chat')
    translationObject.closeButtonText = I18n.translate('js.modules.web_2018.close_button_chat')
    return translationObject;
  }

  open() {
    this.setState({
      open: true
    });
  }


  handleClose() {
    this.setState({
      open: false
    });
  }

  updateChannelSwitchState(event){
    if(document.getElementById("bc-chat-container"))
    {
      this.setState({
        open: false, confirmationPopup: true
      });
      let layeredChat = document.getElementById("bc-chat-container");
      layeredChat.className = layeredChat.className + ' hide-chat'
    }
    else
    {
      var channelsContainer = document.getElementsByClassName('all-channels')[0]
      channelsContainer.dispatchEvent(new CustomEvent('show-popup', {detail: {type: event.detail.type}}));
    }
    this.setState({type: event.detail.type})
  }

  resetChat(){
    this.setState({
      open: false, confirmationPopup: false
    });
  }

  componentDidMount() {
    window.addEventListener('chat-ended', this.routeToThankYouPage);
    if (this.liveChatContainer)
      this.liveChatContainer.addEventListener('click', this.handleClick);
    var channelsContainer = document.getElementsByClassName('all-channels')[0]
    if(channelsContainer)
    {
      channelsContainer.addEventListener('channel-switch', this.updateChannelSwitchState, false);
      channelsContainer.addEventListener('no-operator', this.resetChat, false);
    }
  }

  componentWillUnmount() {
    var thankYouContainer = document.getElementById("thank-you-container-indicator")
    if (thankYouContainer)
      thankYouContainer.removeEventListener('DOMSubtreeModified', this.addEventHandler)
    if (this.liveChatContainer) this.liveChatContainer.removeEventListener('click', this.handleClick)
    window.removeEventListener('chat-ended', this.routeToThankYouPage);
    const floatChatEl = document.querySelector('.bcFloat');
    if (!document.getElementById('bc-chat-container') && floatChatEl) {
        document.body.removeChild(floatChatEl);
      }
  }

  getLiveChatContainerWithWindowOpen(element) {
    return (element.classList.contains('chat-element') || element.getAttribute('id') == 'live-chat-container'
      || element.closest("#live-chat-container").length > 0) && document.getElementById("bc-chat-container")
  }

  handleClick() {
    var element = document.getElementById('live-chat-container')
    if (this.getLiveChatContainerWithWindowOpen(element)) {
      // "click" method is supported by all major browsers: https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/click
      // while the "Event" constructor written earlier is not supported in IE.
      let minEl = document.getElementsByClassName('bc-minimize-state-container')
      if(minEl && minEl[0])
        minEl[0].click();
      return true
    }
    else if (element.getAttribute('id') == 'live-chat-container' || element.classList.contains('chat-element')) {
      var clickContainer = document.getElementsByClassName('bcFloat')[0].getElementsByTagName("a")[0]
      if(clickContainer)
        clickContainer.click();
      return true
    }
  }

  render() {
    if (this.props.params) {
      let chatConfig = this.props.params.contactChannels.chat;
      if (chatConfig) {
        return (
          <div class='chat-channel-container' id='chat-channel-container'>
            <table ref={this.setLiveChatContRef} class={!chatConfig.isAvailable ? 'channel-grid chat-button channel-unavailable' : 'channel-grid chat-button'} id={chatConfig.id} data-bhw={chatConfig.bhw}>
              <tr class="chat-element" id="web-2018-chat">
                <td class="channel-icon-section chat-element">
                  <span class={!chatConfig.isAvailable ? "icon-bubble-closed channel-icon chat-element channel-unavailable" : 'icon-bubble-closed channel-icon chat-element'}></span>
                </td>
                <td class="channel-text-section chat-element">
                  <span class={!chatConfig.isAvailable ? "channel-text chat-element channel-unavailable" : 'channel-text chat-element'}>{chatConfig.channelText}</span>
                  <span class={!chatConfig.isAvailable ? "recommended chat-element channel-unavailable" : 'recommended chat-element'}> {I18n.translate('js.modules.web_2018.recommended')}</span> <br></br>
                  <span class="channel-msg chat-unavailable channel-unavailable">{chatConfig.channelMsg}</span>
                  <span class="channel-msg chat-available chat-element">{chatConfig.chatAvailableMsg}</span>
                </td>
              </tr>
            </table>
            {this.state.confirmationPopup ? (
              <Portal into="body">
                <div class="popup">
                  <ConfirmationPopup handleCloseConfirmationPopup={this.handleCloseConfirmationPopup} handleBackButtonClick={this.handleBackButtonClick}
                    handleCloseButtonClick={this.handleCloseButtonClick} translationObject={this.getTranslationObject()} />
                </div>
                <div class="shadow"></div>
              </Portal>
            ) : null
            }
          </div>
        )
      }
      else {
        return null
      }
    }
  }
}

module.exports = ChatView
